import { Button, Checkbox, FormControlLabel, Stack, Typography } from '@mui/material';
import { paymentSummaryRateTypes } from '@parkchirp/reporting';
import { useCallback } from 'react';

type Props = {
	availableRateTypes?: readonly string[];
	selectedRateTypes: readonly string[];
	onChange: (value: string[]) => void;
};

export const RateTypesFilter = ({
	availableRateTypes = paymentSummaryRateTypes,
	selectedRateTypes,
	onChange,
}: Props) => {
	const allSelected = selectedRateTypes.length === availableRateTypes.length;

	const selectAll = useCallback(() => {
		onChange([...availableRateTypes]);
	}, [availableRateTypes, onChange]);

	const clear = useCallback(() => {
		onChange([]);
	}, [onChange]);

	const handleRateTypeChange = useCallback(
		(rateType: string, checked: boolean) => {
			if (checked) {
				onChange([...selectedRateTypes, rateType]);
				return;
			}

			onChange(selectedRateTypes.filter((selected) => selected !== rateType));
		},
		[onChange, selectedRateTypes],
	);

	return (
		<Stack spacing={2}>
			<Stack direction='row' justifyContent='space-between' alignItems='center'>
				<Typography variant='subtitle1' fontWeight={600}>
					Rate types
				</Typography>

				<Stack direction='row' spacing={1}>
					<Button size='small' variant='text' onClick={selectAll} disabled={allSelected}>
						Select all
					</Button>
					<Button size='small' variant='text' onClick={clear} disabled={selectedRateTypes.length === 0}>
						Clear
					</Button>
				</Stack>
			</Stack>

			<Stack direction='row' flexWrap='wrap' columnGap={3} rowGap={1}>
				{availableRateTypes.map((rateType) => (
					<FormControlLabel
						key={rateType}
						control={
							<Checkbox
								checked={selectedRateTypes.includes(rateType)}
								onChange={(event) => handleRateTypeChange(rateType, event.target.checked)}
							/>
						}
						label={rateType}
					/>
				))}
			</Stack>
		</Stack>
	);
};
